import { fmtPrice, fmtPct } from "@/lib/format";

const RISK_COLOR = { low: "#00E676", medium: "#FFB300", high: "#FF3B30" };

export default function AIRecommendationCard({ signal, onApprove, onReject, busy }) {
  const isHold = signal.direction === "HOLD";
  const dirClass = signal.direction === "BUY" ? "buy" : signal.direction === "SELL" ? "sell" : "hold";
  const conf = Math.round((signal.confidence || 0) * 100);

  return (
    <div className="panel p-4 hover:border-[#00E5FF]/40 transition-colors" data-testid={`signal-card-${signal.id}`}>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-3">
          <div>
            <div className="font-semibold text-base tracking-tight">{signal.symbol}</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#4B5563] font-mono">
              {signal.asset_class === "crypto" ? "CRYPTO" : "EQUITY"} · {signal.broker_id?.toUpperCase() || "—"}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <span className={`tag ${dirClass}`} data-testid={`signal-dir-${signal.id}`}>{signal.direction}</span>
          <span className="tag ai">AI</span>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3 text-[11px] mb-3 font-mono">
        <Field label="ENTRY" value={fmtPrice(signal.suggested_price)} />
        <Field label="STOP" value={fmtPrice(signal.stop_loss)} accent={isHold ? null : "#FF3B30"} />
        <Field label="TARGET" value={fmtPrice(signal.take_profit)} accent={isHold ? null : "#00E676"} />
      </div>

      <div className="text-xs text-[#8B95A5] mb-3 leading-relaxed" data-testid={`signal-reason-${signal.id}`}>
        {signal.reasoning}
      </div>

      <div className="mb-3">
        <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.2em] text-[#8B95A5] mb-1">
          <span>Confidence</span>
          <span className="text-[#00E5FF] font-mono" data-testid={`signal-conf-${signal.id}`}>{conf}%</span>
        </div>
        <div className="confidence-track">
          <div className="confidence-fill" style={{ transform: `scaleX(${conf / 100})` }} />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <span
          className="text-[10px] uppercase tracking-[0.2em] font-mono"
          style={{ color: RISK_COLOR[signal.risk_impact] || "#8B95A5" }}
        >
          ● {signal.risk_impact} risk
        </span>
        <span className="text-[10px] text-[#4B5563] font-mono">
          QTY {fmtPct(signal.suggested_quantity * 100 / 100, 4)}
        </span>
      </div>

      {signal.status === "pending" && !isHold && (
        <div className="grid grid-cols-2 gap-2 mt-4">
          <button
            className="btn-outline"
            disabled={busy}
            onClick={() => onReject(signal)}
            data-testid={`signal-reject-${signal.id}`}
          >
            Reject
          </button>
          <button
            className="btn-primary"
            disabled={busy}
            onClick={() => onApprove(signal)}
            data-testid={`signal-approve-${signal.id}`}
          >
            Approve & Place
          </button>
        </div>
      )}
      {signal.status !== "pending" && (
        <div className="mt-3 text-[10px] uppercase tracking-[0.2em] font-mono text-[#4B5563]">
          {signal.status}
        </div>
      )}
    </div>
  );
}

function Field({ label, value, accent }) {
  return (
    <div>
      <div className="text-[9px] uppercase tracking-[0.2em] text-[#4B5563]">{label}</div>
      <div style={{ color: accent || "#F8F9FA" }} className="mt-1">{value}</div>
    </div>
  );
}
